export default "__VITE_ASSET__22290e6c__"